import { imageTemplates, ImageProps } from './types'

export const Image = ({ url, alt, className, style, template }: ImageProps) => {
  if (!url) return null

  if (template == 'external')
    return <img src={url} alt={alt ?? ''} className={className} style={style} />

  const buildUrl = (format: string) => {
    return `${url}?${imageTemplates[template]}&format=${format}`
  }

  const avifUrl = buildUrl('avif')
  const jpegUrl = buildUrl('jpeg')

  return (
    <picture>
      <source srcSet={avifUrl} type="image/avif" />
      <img src={jpegUrl} alt={alt ?? ''} className={className} style={style} draggable={false} />
    </picture>
  )
}
